import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Button from "react-bootstrap/Button";

import Api from "../../services/Api";
import useAuth from "../login/AuthContext";
import { TimedAlert } from "../../components/TimedAlert";
import { AdminNetworkAccessControls } from "./admin_controls/AdminNetworkAccessControls";
import { MainLayout } from "../../layout/MainLayout";

// TODO: refactor this to use the AdminNetworkAccessControls component and use the AdminAccessRequestControlContainer component

export const AdminAccessRequestControlContainer = () => {
  const [requests, setRequests] = useState([]);
  const [error, setError] = useState({ error: false });
  const { getAuthToken, isWriteAccess } = useAuth();

  const getRequests = async () => {
    const response = await Api.getAdminAccessRequests(await getAuthToken());
    setRequests(response.response);
  };

  useEffect(() => {
    getRequests();
  }, []);

  const columns = [
    {
      dataField: "name",
      text: "Name",
    },
    {
      dataField: "email",
      text: "Email",
    },
    {
      dataField: "organization",
      text: "Organization",
    },
    {
      dataField: "phoneNumber",
      text: "Phone Number",
    },
  ];

  const selectRow = {
    mode: "radio",
    onSelect: (row, isSelect, rowIndex, e) => {
      const accept = async () => {
        const success = await Api.acceptAdminAccessRequests(row.id, await getAuthToken());

        if (!success) {
          setError({ error: true, reason: "Something went wrong" });
        } else {
          getRequests();
        }
      };

      accept();
    },
    selectionRenderer: ({ mode, ...rest }) => (
      <Button type={mode} className="btn">
        Accept
      </Button>
    ),
  };

  return (
    <MainLayout title="Admin Access Request Control">
      {isWriteAccess() && (
        <>
          <TimedAlert
            visible={error.error}
            variant="danger"
            setVisible={(visible) => setError({ ...error, error: visible })}
          >
            {error.reason}
          </TimedAlert>
          <BootstrapTable
            keyField="id"
            data={requests}
            columns={columns}
            striped
            hover
            selectRow={selectRow}
            noDataIndication="No results found"
          />

          <AdminNetworkAccessControls />
        </>
      )}
    </MainLayout>
  );
};

export const ADMIN_ACCESS_REQUEST_CONTROL_URL = "/super-admin/admin-requests";
